var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.923 4H5.077C3.93 4 3 5.007 3 6.25v13.5C3 20.993 3.93 22 5.077 22h13.846C20.07 22 21 20.993 21 19.75V6.25C21 5.007 20.07 4 18.923 4z",
    stroke: "#222",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 11.125a.375.375 0 11-.75 0 .375.375 0 01.75 0zM17.5 11.125a.375.375 0 11-.75 0 .375.375 0 01.75 0zM12.5 14.625a.375.375 0 11-.75 0 .375.375 0 01.75 0zM17.5 14.625a.375.375 0 11-.75 0 .375.375 0 01.75 0zM7.5 14.625a.375.375 0 11-.75 0 .375.375 0 01.75 0zM7.5 18.125a.375.375 0 11-.75 0 .375.375 0 01.75 0zM12.5 18.125a.375.375 0 11-.75 0 .375.375 0 01.75 0zM17.5 18.125a.375.375 0 11-.75 0 .375.375 0 01.75 0zM7.5 11.125a.375.375 0 11-.75 0 .375.375 0 01.75 0z",
    fill: "#222",
    stroke: "#222",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 2.25v1.5M16 2v1.5",
    stroke: "#222",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21 7H3",
    stroke: "#222",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
};

export default SvgCalendar;